<template>
    <div>
        <a-card 
          size="small" 
          title="查询"
          :headStyle='{
            background : "#f3f3f3"
          }'
          >
          <a-form layout="inline">
            <a-form-item>
              <a-input v-model:value="searchForm.businessOrderCode" placeholder="订单编号" allowClear/>

            </a-form-item>
            
            <a-form-item>
              <a-input v-model:value="searchForm.insuredName" placeholder="被保人姓名" allowClear/>
            </a-form-item>

            <a-form-item>
              <a-input v-model:value="searchForm.insureNo" placeholder="保单号" allowClear/>
            </a-form-item>

            <!-- <a-form-item>
              <df-selectChannelShop :model='searchForm' @setValue='searchAction' style='width:220px'></df-selectChannelShop>
            </a-form-item> -->

            <a-form-item>
              <a-range-picker 
                v-model:value='searchForm.orderdate'
                :placeholder='["投保开始","投保结束"]'
                valueFormat='YYYY-MM-DD'
                format='YYYY-MM-DD'
              />
            </a-form-item>

            <a-form-item>
              <a-button type="primary" @click='searchAction'>
                查询
              </a-button>

            </a-form-item>
            <a-form-item>
              <a-button @click="reset">重置</a-button>
            </a-form-item>
            <a-form-item>
              
            </a-form-item>
          </a-form>
        </a-card> 
      <a-card 
        size="small" 
        title=""
  
        style='margin-top:20px'
  
        class='log_content'
        :headStyle='{
          background : "#f3f3f3"
        }'
       
        @tabChange='cardtabChange'
        :tabList = panes
        :bodyStyle='{
          padding : "0"
        }'
    
      >

      <a-table :columns="columns" bordered 
        :data-source="list" 
        :pagination='false' 
        :scroll="{ x: 1300 }"
        :row-key="r => r.id"
        :loading='loading'
        >

        
        <template v-slot:businessOrderCode="{ text,record }">
          <div>{{record.businessOrderCode}}</div>
        </template>

        <template v-slot:extractAmount="{ text,record }">
          <div style='color:red'>¥{{record.extractAmount}}</div>
        </template>

        <template v-slot:premium="{ text,record }">
          <div style='color:red'>¥{{record.premium}}</div>
        </template>

        <template v-slot:rfndOperatorTime="{ text,record }">
          <div v-if='record.rfndOperatorTime'>{{record.rfndOperatorTime}}</div>
          <div v-else>--</div>
        </template>

        <template v-slot:tktsOperatorTime="{ text,record }">
          <div v-if='record.tktsOperatorTime'>{{record.tktsOperatorTime}}</div>
          <div v-else>--</div>
        </template>

        <template v-slot:policyState="{ text,record }">
          <div v-if='record.policyState == 21 || record.policyState == 61' style='color:#cf8b29'>{{policyStateVal[record.policyState]}}</div>
          <div v-else>{{policyStateVal[record.policyState]}}</div>
          <div v-if='record.policyState == 21 || record.policyState == 61'>{{record.remark}}</div>
        </template>


        <template v-slot:operation="{ text,record }">
          <a-button type="primary" @click='reInsured(record)' size='small' v-if='record.policyState == 21'>
            重新投保
          </a-button>

          <a-button type="danger" @click='returnInsurance(record)' size='small' v-if='record.policyState == 61'>
            重新退保
          </a-button>

        </template>

        

        
        
        
      
      </a-table>
    </a-card> 




        <df-pagination :model='pageObj'></df-pagination>
    </div>
</template>

<script>
  import { ref,reactive,provide } from 'vue'
  import orderApi from '@axios/order'
  import { Modal,destroyAll,notification } from 'ant-design-vue';
  export default {
    name: 'insurance',
    components: {

    },
    setup(){

      let activeKey = ref('0');

      let searchForm = reactive({
        businessOrderCode : '',
        insuredName : '',
        insureNo : '',
        distributorId : '',
        orderdate : []
      })

      let searchParams = reactive({
        businessOrderCode : '',
        insuredName : '',
        insureNo : '',
        distributorId : '',
        tktsStartTime : '',
        tktsEndTime : ''
      })

      let pageObj = ref({
          page : 1,
          rows : 10,
          totle : 1
      })

      const searchAction = () =>{
        
        searchParams.businessOrderCode = searchForm.businessOrderCode;
        searchParams.insuredName = searchForm.insuredName;
        searchParams.insureNo = searchForm.insureNo;
        searchParams.distributorId = searchForm.distributorId;
        if(searchForm.orderdate){
          searchParams.tktsStartTime = searchForm.orderdate[0];
          searchParams.tktsEndTime = searchForm.orderdate[1];
        }else{
          searchParams.tktsStartTime = '';
          searchParams.tktsEndTime = '';
        }
        
        pageObj.value = {
          page : 1,
          rows : 10,
          totle : 1
        }
        getList();
      }

      let list = ref([]);

      let loading = ref(false);

      const getList = () => {
        let params = {
          policyState : activeKey.value == '0'?null:activeKey.value,
          businessOrderCode : searchParams.businessOrderCode?searchParams.businessOrderCode:null,
          insuredName : searchParams.insuredName?searchParams.insuredName:null,
          insureNo : searchParams.insureNo?searchParams.insureNo:null,
          distributorId : searchParams.distributorId?searchParams.distributorId:null,
          tktsStartTime : searchParams.tktsStartTime?searchParams.tktsStartTime:null,
          tktsEndTime : searchParams.tktsEndTime?searchParams.tktsEndTime:null,
          currentPage : pageObj.value.page,
          size : pageObj.value.rows
        }

        loading.value = true;

        orderApi.insurance(params).then(res => {
            loading.value = false;
            if(!res) return;
            pageObj.value.totle = res.total;
            pageObj.value.page = res.page;
            list.value = res.data;
        })

      } 
      
      getList();

      const reset = () => {
          searchForm.businessOrderCode = '';
          searchForm.insuredName = '';
          searchForm.insureNo = '';
          searchForm.distributorId = '';
          searchForm.orderdate = [];
          
          searchAction()
      }

      const pageChange = (page) =>{
        pageObj.value.page = page;
        getList();
      }

      const onShowSizeChange = (current,pageSize) =>{
        pageObj.value.page = 1;
        pageObj.value.rows = pageSize;
        getList();
      }


      provide('pageChange',pageChange);
      provide('onShowSizeChange',onShowSizeChange);

      let policyStateVal = {
        10 : '购保中',
        20 : '已购保',
        21 : '购保失败',
        30 : '批改中',
        40 : '已批改',
        41 : '批改失败',
        50 : '退保中',
        60 : '已退保',
        61 : '退保失败',
        90 : '取消',
      }

      const reInsured = (item) => {
        let params = {
          serialNumber : item.serialNumber
        }
        orderApi.reInsurance(params).then((res)=>{
          notification.open({
            message: '重新发起投保成功',
            icon: <SmileOutlined  style="color: #108ee9" />,
          });
          searchAction();
        })  
      }

      const returnInsurance = (item) => {
        let params = {
          serialNumber : item.serialNumber
        }
        orderApi.returnInsuranceAgain(params).then((res)=>{
          notification.open({
            message: '重新发起退保成功',
            icon: <SmileOutlined  style="color: #108ee9" />,
          });
          searchAction();
        })  
      }

      let panes = ref([
        { tab: '全部', key: '0' },
        { tab: '成功保单', key: '20' },
        { tab: '已退保单', key: '60' },
        { tab: '投保失败', key: '21' },
        { tab: '退保失败', key: '61' },
      ]);

      const cardtabChange = (key) => {
        activeKey.value = key;
        reset();
      }

      return {
        activeKey,
        cardtabChange,
        panes,
        returnInsurance,
        reInsured,
        policyStateVal,
        loading,
        list,
        pageObj,
        searchForm,
        searchAction,
        reset,
        columns: [
          {
            title: '订单编号',
            dataIndex: 'businessOrderCode',
            width: 200,
            align : 'center',
            slots: { customRender: 'businessOrderCode' },

          },
          {
            title: '保单号',
            dataIndex: 'insureNo',
            width: 220,
            align : 'center',
            
          },
          {
            title: '被保人姓名',
            dataIndex: 'insuredName',
            width: 120,
            align : 'center',
            
          },
          {
            title: '证件号码',
            dataIndex: 'insuredId',
            width: 200,
            align : 'center',
            
          },
          {
            title: '保险名称',
            dataIndex: 'supplierInsuranceName',
            width: 150,
            align : 'center',
            
          },
          {
            title: '手续费',
            dataIndex: 'extractAmount',
            width: 100,
            align : 'center',
            slots: { customRender: 'extractAmount' },
          },
          {
            title: '投保金额',
            dataIndex: 'premium',
            width: 100,
            align : 'center',
            slots: { customRender: 'premium' },
          },
          {
            title: '保险公司',
            dataIndex: 'supplierName',
            width: 100,
            align : 'center',
            
          },
          {
            title: '投保时间',
            dataIndex: 'tktsOperatorTime',
            width: 200,
            align : 'center',
            slots: { customRender: 'tktsOperatorTime' },
          },
          {
            title: '退保时间',
            dataIndex: 'rfndOperatorTime',
            width: 200,
            align : 'center',
            slots: { customRender: 'rfndOperatorTime' },
          },
          {
            title: '保单状态',
            dataIndex: 'policyState',
            width: 250,
            align : 'center',
            slots: { customRender: 'policyState' },
          },
          {
            title: '操作',
            dataIndex: 'operation',
            width: 110,
            align : 'center',
            slots: { customRender: 'operation' },
          },
          
        ]
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .table_logo{
      width: 70px;
      
  }
</style>



